
    import React from "react";
    import { Spin } from 'antd';
    const A_65bc9dbc4fedcdc51872b47fef2f03fb = React.lazy(() => import(/* webpackChunkName: "A000" */ "@/dynamic/pages/uniform变量/详解uniform全局变量"));
const A_e9509ceee9888040eb2d9d0b8bf5be7d = React.lazy(() => import(/* webpackChunkName: "A010" */ "@/dynamic/pages/二维/平移"));
const A_87ce50e53772fdbb0cf8d82006def2a1 = React.lazy(() => import(/* webpackChunkName: "A011" */ "@/dynamic/pages/二维/旋转"));
const A_3ce98fbdd36e02341d52bb635faee2f0 = React.lazy(() => import(/* webpackChunkName: "A020" */ "@/dynamic/pages/坐标系统/画布尺寸及视口"));
const A_77c4683dbf9e9f034d63161c9c8d5e21 = React.lazy(() => import(/* webpackChunkName: "A021" */ "@/dynamic/pages/坐标系统/纹理坐标"));
const A_4437a40fb80afab6889e3b397951dd93 = React.lazy(() => import(/* webpackChunkName: "A022" */ "@/dynamic/pages/坐标系统/齐次坐标"));
const A_3d5027b61cd045fec9560b511695a195 = React.lazy(() => import(/* webpackChunkName: "A030" */ "@/dynamic/pages/基础知识/webgl流程线及基本概念"));
const A_ec392687c3e707be9955fc56b4288859 = React.lazy(() => import(/* webpackChunkName: "A031" */ "@/dynamic/pages/基础知识/调试工具"));
const A_7526fbc4a510d0439c96ac26fae7e9ad = React.lazy(() => import(/* webpackChunkName: "A032" */ "@/dynamic/pages/基础知识/颜色缓冲区简介"));
const A_32cc6353a446dbd2a45af4a6fdca0818 = React.lazy(() => import(/* webpackChunkName: "A040" */ "@/dynamic/pages/属性和缓冲/size和属性默认值"));
const A_7f8d332ebf7a3250162d04796df7e6f0 = React.lazy(() => import(/* webpackChunkName: "A041" */ "@/dynamic/pages/属性和缓冲/属性在WebGL内部的表示"));
const A_c7202bc559bec0e840b2042d8838c233 = React.lazy(() => import(/* webpackChunkName: "A042" */ "@/dynamic/pages/属性和缓冲/属性的两种赋值方式"));
const A_47575014b4fd92e2eeaf55f2e529a14d = React.lazy(() => import(/* webpackChunkName: "A043" */ "@/dynamic/pages/属性和缓冲/详解vertexAttribPointer"));
const A_c77f35952e674cf797206cf97869f57a = React.lazy(() => import(/* webpackChunkName: "A044" */ "@/dynamic/pages/属性和缓冲/通过缓冲传递坐标和颜色值"));
const A_d27333fce66a2bf30b0481ab56bfe75e = React.lazy(() => import(/* webpackChunkName: "A050" */ "@/dynamic/pages/纹理/texImage2D详解"));
const A_829df07948315966e154021bebb4842d = React.lazy(() => import(/* webpackChunkName: "A051" */ "@/dynamic/pages/纹理/为什么纹理是颠倒的"));
const A_f408cff0701322fc2a46d639aaad59b5 = React.lazy(() => import(/* webpackChunkName: "A052" */ "@/dynamic/pages/纹理/纹理单元及底层表示"));
const A_091f406ac58a06082b5f415d08708801 = React.lazy(() => import(/* webpackChunkName: "A053" */ "@/dynamic/pages/纹理/纹理尺寸"));
const A_5315928f405293d30ee6c1948750cd35 = React.lazy(() => import(/* webpackChunkName: "A054" */ "@/dynamic/pages/纹理/纹理的简单使用"));

    const routes = [
{
             path: "/uniform变量/详解uniform全局变量",
             element: (
                <React.Suspense fallback={<div className="loading"><Spin size="large" /></div>}>
                <A_65bc9dbc4fedcdc51872b47fef2f03fb />
                </React.Suspense>
             ),
           },
{
             path: "/二维/平移",
             element: (
                <React.Suspense fallback={<div className="loading"><Spin size="large" /></div>}>
                <A_e9509ceee9888040eb2d9d0b8bf5be7d />
                </React.Suspense>
             ),
           },
{
             path: "/二维/旋转",
             element: (
                <React.Suspense fallback={<div className="loading"><Spin size="large" /></div>}>
                <A_87ce50e53772fdbb0cf8d82006def2a1 />
                </React.Suspense>
             ),
           },
{
             path: "/坐标系统/画布尺寸及视口",
             element: (
                <React.Suspense fallback={<div className="loading"><Spin size="large" /></div>}>
                <A_3ce98fbdd36e02341d52bb635faee2f0 />
                </React.Suspense>
             ),
           },
{
             path: "/坐标系统/纹理坐标",
             element: (
                <React.Suspense fallback={<div className="loading"><Spin size="large" /></div>}>
                <A_77c4683dbf9e9f034d63161c9c8d5e21 />
                </React.Suspense>
             ),
           },
{
             path: "/坐标系统/齐次坐标",
             element: (
                <React.Suspense fallback={<div className="loading"><Spin size="large" /></div>}>
                <A_4437a40fb80afab6889e3b397951dd93 />
                </React.Suspense>
             ),
           },
{
             path: "/基础知识/webgl流程线及基本概念",
             element: (
                <React.Suspense fallback={<div className="loading"><Spin size="large" /></div>}>
                <A_3d5027b61cd045fec9560b511695a195 />
                </React.Suspense>
             ),
           },
{
             path: "/基础知识/调试工具",
             element: (
                <React.Suspense fallback={<div className="loading"><Spin size="large" /></div>}>
                <A_ec392687c3e707be9955fc56b4288859 />
                </React.Suspense>
             ),
           },
{
             path: "/基础知识/颜色缓冲区简介",
             element: (
                <React.Suspense fallback={<div className="loading"><Spin size="large" /></div>}>
                <A_7526fbc4a510d0439c96ac26fae7e9ad />
                </React.Suspense>
             ),
           },
{
             path: "/属性和缓冲/size和属性默认值",
             element: (
                <React.Suspense fallback={<div className="loading"><Spin size="large" /></div>}>
                <A_32cc6353a446dbd2a45af4a6fdca0818 />
                </React.Suspense>
             ),
           },
{
             path: "/属性和缓冲/属性在WebGL内部的表示",
             element: (
                <React.Suspense fallback={<div className="loading"><Spin size="large" /></div>}>
                <A_7f8d332ebf7a3250162d04796df7e6f0 />
                </React.Suspense>
             ),
           },
{
             path: "/属性和缓冲/属性的两种赋值方式",
             element: (
                <React.Suspense fallback={<div className="loading"><Spin size="large" /></div>}>
                <A_c7202bc559bec0e840b2042d8838c233 />
                </React.Suspense>
             ),
           },
{
             path: "/属性和缓冲/详解vertexAttribPointer",
             element: (
                <React.Suspense fallback={<div className="loading"><Spin size="large" /></div>}>
                <A_47575014b4fd92e2eeaf55f2e529a14d />
                </React.Suspense>
             ),
           },
{
             path: "/属性和缓冲/通过缓冲传递坐标和颜色值",
             element: (
                <React.Suspense fallback={<div className="loading"><Spin size="large" /></div>}>
                <A_c77f35952e674cf797206cf97869f57a />
                </React.Suspense>
             ),
           },
{
             path: "/纹理/texImage2D详解",
             element: (
                <React.Suspense fallback={<div className="loading"><Spin size="large" /></div>}>
                <A_d27333fce66a2bf30b0481ab56bfe75e />
                </React.Suspense>
             ),
           },
{
             path: "/纹理/为什么纹理是颠倒的",
             element: (
                <React.Suspense fallback={<div className="loading"><Spin size="large" /></div>}>
                <A_829df07948315966e154021bebb4842d />
                </React.Suspense>
             ),
           },
{
             path: "/纹理/纹理单元及底层表示",
             element: (
                <React.Suspense fallback={<div className="loading"><Spin size="large" /></div>}>
                <A_f408cff0701322fc2a46d639aaad59b5 />
                </React.Suspense>
             ),
           },
{
             path: "/纹理/纹理尺寸",
             element: (
                <React.Suspense fallback={<div className="loading"><Spin size="large" /></div>}>
                <A_091f406ac58a06082b5f415d08708801 />
                </React.Suspense>
             ),
           },
{
             path: "/纹理/纹理的简单使用",
             element: (
                <React.Suspense fallback={<div className="loading"><Spin size="large" /></div>}>
                <A_5315928f405293d30ee6c1948750cd35 />
                </React.Suspense>
             ),
           },

]

    export default routes;
    